import { Input } from '@angular/core';
import { DataModelComponent } from '../models/data.model.component';
import { AngularFirestore } from 'angularfire2/firestore';
import { DataModel, getTableNameFull } from '../models/data.model';
import { Formatter } from '../comum/pipes/formatter';
import { Subscription, Subject, Observable } from 'rxjs';
import { ChatMessages } from '../models/ChatMessages.model'
import { UsersService } from './usuarios.service';
import {EstadoItens} from '../models/estadoItens.model'

export interface IPedido {
    pedido: string,
    pedidoId: string,
    items: Array<any>,
    entrega: any,
}

export class PedidoModel extends DataModelComponent<any>{
    codEstado: number = 0;

    chatModel: ChatMessages;
    pedidoClass: DataModel<any>;
    pedidoEvent: Subscription;
    pedidos: any[any] = [];
    pedidosCount: number;
    private estadoItens : EstadoItens
    user: any;
    @Input()
    fornecedor: number = 0;
    @Input()
    estados: Array<any> = [];
    changeEvent: Subject<any> = new Subject();
    contaPlayAudio:number = 0;
    playAudio(wav) {
        console.log('tocando sino')
        if (this.contaPlayAudio==0){
          let audio = new Audio();
          audio.src = "../../../assets/" + wav;
          audio.load();
          audio.play();
          this.contaPlayAudio++;
        }
    }

    constructor(private dbConn: AngularFirestore,
        private users: UsersService) {
        super({});
        this.user = users;
        this.pedidoClass = new DataModel(dbConn, "carrinhoItems");
        this.pedidoEvent = this.pedidoClass.changedEvent
            .subscribe(
                d => {
                    //this.contaPlayAudio = 0;
                    console.log('tocar ',this.pedidos);
                    this.pedidos = this.agruparItens(d);
                    //console.log('pedidos: ',this.pedidos);
                    if (this.pedidosCount && this.pedidosCount < this.pedidos.length)
                        if (this.pedidos.items[0].estado == 0)
                            this.playAudio("novoPedido.wav");
                    this.pedidosCount = this.pedidos.length;
                    this.changeEvent.next(this.pedidos);
                })
        this.chatModel = new ChatMessages(dbConn);
        this.estadoItens = new EstadoItens(dbConn)

        this.estadoItens.snapshot(function(elem)
        {
           return elem.where('inativo','==',false)  
        },(data : any)=>
        {  
            this.estados = data     
        },true)
    }
    subscribe() {
        return this.changeEvent;
    }

    inited(aFornecedor: number, aEstado: number): void {
        this.fornecedor = aFornecedor;
        this.codEstado = aEstado;
    }

    async alterarEstado(pedido: any, item: any, paraEstado: Number) : Promise<any> {
        let x = Number(paraEstado);
        return await 
        this.dbConn.collection(getTableNameFull("carrinhoItems"))
        .doc(item.id).update({ estado: x })
    }

    enviarMensagemMovimentacaoEstado(paraEmail, pedido, item, estado) {
        const nPedido = item.pedido
        let mensagem = "O item <" + item.nome + "> foi movimentado para: " + estado.nome +
            " - " + estado.info + "";
        let emailDe = this.user.usuario.email;
        this.chatModel.enviarPara('pedido', nPedido,
            'Pedido: ' + nPedido+ ' - '+estado.nome,
            emailDe, paraEmail, mensagem);
    }

    carregarPedidos(aFornecedor: number, aCodEstado, aDataPedido?: Date) {
        
        if (!(aFornecedor === this.fornecedor && aCodEstado === this.codEstado)) 
        {
            this.fornecedor = (aFornecedor ? Number(aFornecedor) : 0);
            this.codEstado = (aCodEstado ? Number(aCodEstado) : 0);

            if (this.codEstado < 500) aDataPedido = null; // desliga o filtro de data

            if ((this.pedidoClass) && (this.codEstado >= 0)) 
            {
                let where : Function = 
                (r)=> 
                {
                    if (aDataPedido) 
                    {
                        aDataPedido = DataModel.toDate(aDataPedido);            
                        return  r.where("data", ">=", aDataPedido)
                        .where("estado", "==", this.codEstado)
                        .where("fornecedor", "==", this.fornecedor);
                    } 
                    else 
                    {
                        if (aCodEstado >= 500) 
                        {                           
                          return r.where("estado", "==", this.codEstado)
                          .where("fornecedor", "==", this.fornecedor).orderBy("data").limit(500);
                        } 
                        else
                        { 
                           return r.where("estado", "==", this.codEstado)
                           .where("fornecedor", "==", this.fornecedor)
                        }    
                    }
                }
                this.pedidoClass.snapshot(where);
            }
        }
    }



    agruparItens(d) {
        let its = [];
        let k = 0;
        d.forEach(item => {
            if (item.estado == this.codEstado) {
                let tmp = null;
                its.forEach(element => {
                    if (element.pedidoId == item.pedidoId) {
                        element.items.push(item);
                        tmp = true;
                    }
                });
                if (!tmp) {
                    its.push(
                        {
                            pedido: item.pedido,
                            index: k++,
                            pedidoId: item.pedidoId,
                            items: [item],
                            entrega: item.entrega
                        }
                    )
                }
            }
        });


        return its;
    }

    public static getItemsCount(pedido) {
        if (pedido.items != null)
            if (pedido) return pedido.items.length;
    }
    public static getPesoTotal(pedido) {
        return 0;
    }

    public static formatQtde(v) {
        var d = 3;
        if (Math.abs(v / 1000) * 1000 == v) {
            d = 0;
        };
        return Formatter.formatNumber(v, d, ',')
    }
    localizaEstado(codigo) {
        
        return this.estados.filter(function(elem){ return (elem.codigo == codigo) })[0]
    }

    isPedidoValido(idx) {
        return ((idx >= 0) && (idx < this.pedidos.length));
    }
    localizaEstadoAnterior(codigo) {
        let rt;
        this.estados.forEach(element => {
            if (!rt && (element.proximo == codigo)) {
                rt = element;
            }
        });
        return rt;
    }


    DoEstadoDecrease(idx) {
        if (this.isPedidoValido(idx)) {
            let ped = this.pedidos[idx];
            if (ped)
                ped.items.forEach(element => {
                    if (element.checked) {
                        console.log(element);
                        let estado = this.localizaEstado(element.estado);
                        if (estado && Number(estado.anterior) >= 0) {
                            this.alterarEstado(ped, element, Number(estado.anterior));
                        } else {
                            let x = this.localizaEstadoAnterior(element.estado);
                            if (x) {
                                this.alterarEstado(ped, element, Number(x.codigo))
                                .then(()=>{
                                    let email = element.cliente.email 
                                    this.enviarMensagemMovimentacaoEstado(email,
                                    ped.items,element,estado)
                                })   
                            }
                        }
                    }
                });
        }
    }

    async alterarEstadoTodos(idx, paraEstado) 
    {
        if (this.isPedidoValido(idx)) 
        {
            let ped = this.pedidos[idx];
            if (ped)
            {
                for(let element of ped.items)
                {
                    await this.alterarEstado(ped, element, Number(paraEstado))
                    let email = element.cliente.email 
                    this.enviarMensagemMovimentacaoEstado(email,
                    ped.items,element,element.estado)
                }
            }         
        }
    }

    DoEstadoIncrease(idx) 
    {
        if (this.isPedidoValido(idx)) 
        {
            let ped = this.pedidos[idx];
            if (ped)
            {
                ped.items.forEach(element => {
                    if (element.checked) 
                    {
                        let x = this.localizaEstado(element.estado);
                        if (x) {
                            this.alterarEstado(ped, element, Number(x.proximo))
                            .then(()=>{
                                let email = element.cliente.email 
                                this.enviarMensagemMovimentacaoEstado(email,
                                ped.items,element,x)
                            })  
                        } else {
                            console.log("Não achou estado: " + element.estado);
                        }
                    }  
                });
            }    
        }
    }

    procurarPor(aNome: string) {
        this.pedidoClass.snapshot(
            r => {
                r.where("entrega.nome", "==", aNome)
                return r;
            }
        );
    }

}